import React from "react";
import type { ICellRendererParams } from "ag-grid-community";
import { useActionsCellController } from "./ActionsCell.controller.ts";
import type { UserUserIO } from "../../../../generated/fresh-guard-api";
import styles from "./ActionsCell.module.css";
import {
  FaBagShopping,
  FaKey,
  FaPencil,
  FaRegCirclePlay,
  FaRegCircleStop,
} from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import type { ActionsCellType } from "./ActionsCell.type.ts";
import LoaderView from "../../../../components/loader/Loader.view.tsx";

export default function ActionsCellView(
  props: ICellRendererParams<UserUserIO> & ActionsCellType,
) {
  const { t } = useTranslation();
  const {
    onEdit,
    onDeactivate,
    onActivate,
    onSelectMarkets,
    onResetPassword,
    loading,
  } = useActionsCellController(props);

  return (
    <div className={styles.iconContainer}>
      {loading && <LoaderView />}
      {!loading && (
        <>
          {props.data?.deactivated && (
            <FaRegCirclePlay
              className={`${styles.icon} ${styles.iconYellow}`}
              onClick={onActivate}
              title={t("table.userManagement.activate")}
            />
          )}
          {!props.data?.deactivated && (
            <>
              <FaRegCircleStop
                className={`${styles.icon} ${styles.iconRed}`}
                onClick={onDeactivate}
                title={t("table.userManagement.deactivate")}
              />
              <FaBagShopping
                className={`${styles.icon} ${styles.iconBlue}`}
                onClick={onSelectMarkets}
                title={t("table.userManagement.selectMarkets")}
              />
              <FaKey
                className={`${styles.icon} ${styles.iconOrange}`}
                onClick={onResetPassword}
                title={t("table.userManagement.resetPassword")}
              />
              <FaPencil
                className={`${styles.icon} ${styles.iconGreen}`}
                onClick={onEdit}
                title={t("table.userManagement.edit")}
              />
            </>
          )}
        </>
      )}
    </div>
  );
}
